import * as angular from "angular";
import { SearchUtils } from "../../helper/search.helper";

export class NavigationBarHelperService {
    private $mdMedia: any;
    private $window: any;
    private searchUtils: SearchUtils;
    private readonly __env: any;

    public filterOpen = false;
    public filterOffset = false;
    public navigationBarHidden = false;
    public sideBarOpen: boolean;
    public smallScreen: boolean;
    public searchMode = false;
    public showFilterButton = false;
    public autoSideBar = false;
    public pageChanged = false;
    public selectedPage: any = null;
    public paths: object;
    public menuItemsHidden?: boolean;
    public screenSize?: string;
    public profileMenuHidden?: boolean;
    public hideSideBar?: boolean;
    public showBackButton?: boolean;
    public mini_side_nav: boolean = true;
    public pinnedPageClicked: boolean = false;
    public pages: any;
    public leaderPages: any;
    public isLeaderView: boolean;

    constructor(
        $mdMedia: any,
        $window: any,
        SearchUtils: SearchUtils,
        __app_type: string,
        __env: any
    ) {
        this.$mdMedia = $mdMedia;
        this.$window = $window;
        this.searchUtils = SearchUtils;
        this.__env = __env;
        this.isLeaderView = __app_type === "LEADER";

        this.sideBarOpen = !this.$mdMedia("xs");
        this.smallScreen = this.$mdMedia("xs");
        window.addEventListener(
            "resize",
            () => {
                let width = this.$window.innerWidth;
                if (this.autoSideBar) {
                    this.setSideBarOpen(width >= 960);
                }
                this.smallScreen = width < 960;

                if (this.smallScreen) {
                    this.screenSize = "sm";
                } else if (width < 1280) {
                    this.screenSize = "md";
                } else {
                    this.screenSize = "lg";
                }
            },
            true
        );
        this.setUpPaths();
    }

    setUpPaths(): void {
        this.paths = {
            "": {
                sidebar: "results",
                title: "Dashboards",
                navbar: "white",
                icon: "space_dashboard",
            },
            results: {
                sidebar: "results",
                title: "Dashboards",
                icon: "space_dashboard",
            },
            people: {
                sidebar: "people",
                title: "Database",
                navbar: "white",
                navborder: false,
            },
            map: {
                sidebar: "map",
                title: "Map",
                // navbar: "fully-transparent",
                navbar: "white",
                navborder: true,
            },
            customize: {
                sidebar: "customize",
                title: "Customize",
                description:
                    "Tailor features within the app to suit your account",
                navbar: "white",
                navborder: true,
            },
            voterfiles: {
                sidebar: "import",
                navbar: "white",
                title: "Imports & Exports",
                icon: "import_export",
                navborder: true,
            },
            nationbuilder: {
                sidebar: "import",
                title: "NationBuilder",
                navbar: "white",
                navborder: true,
            },
            choose_import: {
                sidebar: "import",
                title: "Imports & Exports",
                icon: "import_export",
                navbar: "white",
                navborder: true,
            },
            houses: {
                sidebar: "people",
                title: "Database",
                navbar: "white",
                navborder: false,
            },
            duplicates: {
                sidebar: "people",
                title: "Duplicates",
            },
            streets: {
                sidebar: "people",
                title: "Database",
                navbar: "white",
                navborder: false,
            },
            lists: {
                sidebar: "people",
                title: "Database",
                navbar: "white",
                navborder: false,
            },
            leader_houses: {
                sidebar: "leader_people",
                title: "Database",
                navbar: "white",
                navborder: false,
            },
            leader_dashboards: {
                sidebar: "leader_dashboards",
                title: "Dashboards",
                navbar: "white",
                icon: "space_dashboard",
            },
            leader_streets: {
                sidebar: "leader_people",
                title: "Database",
                navbar: "white",
                navborder: false,
            },
            leader_lists: {
                sidebar: "leader_people",
                title: "Database",
                navbar: "white",
                navborder: false,
            },
            leader_users: {
                sidebar: "leader_users",
                title: "Users",
                navbar: "white",
                navborder: false,
            },
            leader_locations: {
                sidebar: "leader_people",
                title: "Database",
                navbar: "white",
                navborder: true,
            },
            canvasser: {
                sidebar: "canvasser_tracking",
                title: "Field Tracking",
                navbar: "white",
                navborder: false,
            },
            integration: {
                sidebar: "integration",
                title: "Integrations",
                navbar: "white",
                navborder: true,
            },
            appointments: {
                sidebar: "appointments",
                title: "Planner",
                description:
                    "Schedule and manage your online and in-person meetings in one convenient place",
                navbar: "white",
                navborder: false,
            },
            events: {
                sidebar: "appointments",
                title: "Planner",
                description:
                    "Schedule and manage your online and in-person meetings in one convenient place",
                navbar: "white",
                navborder: false,
            },
            assignments: {
                sidebar: "appointments",
                title: "Planner",
                description:
                    "View and manage your List Assignments for your entire team",
                navbar: "white",
                navborder: false,
            },
            teams: {
                sidebar: "team",
                title: "Users & Teams",
                navbar: "white",
                navborder: false,
            },
            invites: {
                sidebar: "team",
                title: "Users & Teams",
                navbar: "white",
                navborder: false,
            },
            users: {
                sidebar: "team",
                title: "Users & Teams",
                navbar: "white",
                navborder: false,
            },
            user: {
                sidebar: "team",
                title: "Users & Teams",
                navbar: "white",
                navborder: false,
            },
            user_map: {
                sidebar: "team",
                title: "Users & Teams",
                navbar: "white",
                navborder: false,
            },
            qr: {
                sidebar: "team",
                title: "Users & Teams",
                navbar: "white",
                navborder: false,
            },
            issues: {
                sidebar: "issues",
                title: "Helpdesk",
                navbar: "white",
                navborder: true,
            },
            survey: {
                sidebar: "survey",
                title: "Surveys",
                navbar: "white",
                navborder: true,
            },
            contact: {
                sidebar: "contact",
                title: "Email Blast",
            },
            exports: {
                sidebar: "import",
                title: "Imports & Exports",
                navbar: "white",
                navborder: true,
                icon: "import_export",
            },
            profile: {
                sidebar: "",
                title: "Profile Settings",
                icon: "account_circle",
            },
            cancel: {
                sidebar: "",
                title: "Cancel Account",
            },
            campaign: {
                sidebar: "",
                title: "Account Settings",
                icon: "account_balance",
            },
            createcampaign: {
                sidebar: "",
                title: "Create Account",
            },
            divisions: {
                sidebar: "divisions",
                title: "Home",
                navbar: "white",
                navborder: false,
                icon: "home",
            },
            leader_settings: {
                sidebar: "divisions",
                title: "Home",
                icon: "home",
                navbar: "white",
                navborder: true,
            },
            leader_people: {
                sidebar: "leader_people",
                title: "Database",
                navbar: "white",
                navborder: false,
            },
            leader_leaderboard: {
                sidebar: "leader_leaderboard",
                title: "Leaderboard",
                navbar: "white",
                navborder: true,
            },
            leader_map: {
                sidebar: "leader_map",
                title: "Map",
            },
            leader_results: {
                sidebar: "leader_results",
                title: "Analytics",
                icon: "insert_chart",
                navbar: "white",
                navborder: true,
            },
            leader_customize: {
                sidebar: "leader_customize",
                title: "Customize",
                icon: "layers",
                navbar: "white",
                navborder: true,
            },
            leader_voterfiles: {
                sidebar: "leader_voterfiles",
                title: "Imports & Exports",
                navbar: "white",
                navborder: true,
                icon: "import_export",
            },
            leader_exports: {
                sidebar: "leader_voterfiles",
                title: "Exports",
                navbar: "white",
                icon: "import_export",
            },
            leader_talkingpoint: {
                sidebar: "leader_talkingpoint",
                title: "Talking Points",
            },
            leader_survey: {
                sidebar: "leader_survey",
                title: "Surveys",
            },
            privacy: {
                sidebar: "privacy",
                title: "Privacy Dashboard",
                icon: "security",
            },
            admin_logins: {
                sidebar: "admin_logins",
                title: "Logins",
                icon: "shield",
            },
            admin_campaigns: {
                sidebar: "admin_campaigns",
                title: "Accounts",
                icon: "account_balance",
            },
            admin_users: {
                sidebar: "admin_users",
                title: "Users",
                icon: "person",
            },
            admin_organisations: {
                sidebar: "admin_organisations",
                title: "Organisations",
                icon: "language",
            },
            admin_live: {
                sidebar: "admin_live",
                title: "Live activity",
                icon: "directions_walk",
            },
            accountdetails: {
                sidebar: "",
                title: "Account Details",
                showBackButton: true,
            },
        };
    }

    toggleFilterButton(show: boolean): void {
        this.showFilterButton = show;
    }

    setPages(permissionProvider: any): void {
        this.pages = {
            plan: {
                name: "Plan",
                permission: () => {
                    return true;
                },
                pages: [
                    {
                        name: "Database",
                        icon: "location_city",
                        key: "people",
                        url: "#/people",
                        permission: () => {
                            return true;
                        },
                    },
                    {
                        name: "Map",
                        icon: "map",
                        key: "map",
                        url: "#/map",
                        permission: () => {
                            return true;
                        },
                    },
                    {
                        name: "Customize",
                        icon: "layers",
                        key: "customize",
                        url: "#/customize",
                        permission: () => {
                            return permissionProvider.hasPermission(
                                "CUSTOM_FIELDS"
                            );
                        },
                    },
                    {
                        name: "Integrations",
                        icon: "build",
                        key: "integration",
                        url: "#/integration",
                        permission: () => {
                            return (
                                permissionProvider.hasPermission(
                                    "NOT_CANVASSER"
                                ) &&
                                permissionProvider.hasPermission("INTEGRATION")
                            );
                        },
                    },
                ],
            },
            organize: {
                name: "Organize",
                permission: () => {
                    return true;
                },
                pages: [
                    {
                        name: "Users & Teams",
                        icon: "group",
                        key: "team",
                        url: "#/users",
                        permission: () => {
                            return permissionProvider.hasPermission(
                                "NOT_CANVASSER"
                            );
                        },
                    },
                    {
                        name: "Planner",
                        icon: "event",
                        key: "appointments",
                        url: "#/appointments",
                        permission: () => {
                            return true;
                        },
                    },
                    {
                        name: "Surveys",
                        icon: "playlist_add_check",
                        key: "survey",
                        url: "#/survey",
                        permission: () => {
                            return (
                                permissionProvider.hasPermission(
                                    "NOT_CANVASSER"
                                ) && permissionProvider.hasPermission("SURVEY")
                            );
                        },
                    },
                ],
            },
            engage: {
                name: "Engage",
                permission: () => {
                    return (
                        permissionProvider.hasPermission("NOT_CANVASSER") &&
                        (permissionProvider.hasPermission("ISSUE") ||
                            permissionProvider.hasPermission(
                                "CANVASSER_TRACKING"
                            ))
                    );
                },
                pages: [
                    {
                        name: "Field Tracking",
                        icon: "my_location",
                        key: "canvasser_tracking",
                        url: "#/canvasser/activity",
                        permission: () => {
                            return (
                                permissionProvider.hasPermission(
                                    "CANVASSER_TRACKING"
                                ) &&
                                permissionProvider.hasPermission(
                                    "NOT_CANVASSER"
                                )
                            );
                        },
                    },
                    {
                        name: "Helpdesk",
                        icon: "question_answer",
                        key: "issues",
                        url: "#/issues",
                        permission: () => {
                            return (
                                permissionProvider.hasPermission("ISSUE") &&
                                permissionProvider.hasPermission(
                                    "NOT_CANVASSER"
                                )
                            );
                        },
                    },
                ],
            },
            other: {
                permission: () => {
                    return true;
                },
                pages: [
                    {
                        name: "Support Center",
                        icon: "help_outline",
                        key: "support",
                        url: "https://support.ecanvasser.com/en/",
                        new_tab: true,
                        permission: () => {
                            return true;
                        },
                    },
                    {
                        name: "Refer & Earn",
                        icon: "monetization_on",
                        key: "refer",
                        url: "https://ecanvasser.getrewardful.com/signup",
                        permission: () => {
                            return permissionProvider.hasPermission(
                                "NOT_CANVASSER"
                            );
                        },
                    },
                ],
            },
        };
        this.leaderPages = {
            plan: {
                name: "Plan",
                permission: () => {
                    return true;
                },
                pages: [
                    {
                        name: "Database",
                        icon: "location_city",
                        key: "leader_people",
                        url: "#/leader_people",
                        permission: () => {
                            return true;
                        },
                    },
                    {
                        name: "Customize",
                        icon: "layers",
                        key: "leader_customize",
                        url: "#/leader_customize",
                        permission: () => {
                            return permissionProvider.hasPermission(
                                "LEADER_CUSTOMISE"
                            );
                        },
                    },
                ],
            },
            organize: {
                name: "Organize",
                permission: () => {
                    return (
                        permissionProvider.hasPermission("LEADER_ORGANIZE") ||
                        permissionProvider.hasPermission("LEADER_USER")
                    );
                },
                pages: [
                    {
                        name: "Users",
                        icon: "group",
                        key: "leader_users",
                        url: "#/leader_users",
                        permission: () => {
                            return permissionProvider.hasPermission(
                                "LEADER_USER"
                            );
                        },
                    },
                    {
                        name: "Leaderboard",
                        icon: "emoji_events",
                        key: "leader_leaderboard",
                        url: "#/leader_leaderboard",
                        permission: () => {
                            return permissionProvider.hasPermission(
                                "LEADER_LEADERBOARD"
                            );
                        },
                    },
                    {
                        name: "Surveys",
                        icon: "playlist_add_check",
                        key: "leader_survey",
                        url: "#/leader_survey",
                        permission: () => {
                            return permissionProvider.hasPermission(
                                "LEADER_ORGANIZE"
                            );
                        },
                    },
                ],
            },
            other: {
                permission: () => {
                    return true;
                },
                pages: [
                    {
                        name: "Support Center",
                        icon: "help_outline",
                        key: "support",
                        url: "https://support.ecanvasser.com/en/",
                        new_tab: true,
                        permission: () => {
                            return true;
                        },
                    },
                    {
                        name: "Refer & Earn",
                        icon: "monetization_on",
                        key: "refer",
                        url: "https://ecanvasser.getrewardful.com/signup",
                        permission: () => {
                            return permissionProvider.hasPermission(
                                "NOT_CANVASSER"
                            );
                        },
                    },
                ],
            },
        };
    }

    setAutoSidebar(bool: boolean): void {
        this.autoSideBar = bool;
    }

    getMiniBrandIcon(bool: boolean): void {
        this.autoSideBar = bool;
    }

    setSearchMode(searchMode: boolean): void {
        if (!this.pageChanged) {
            this.searchMode = this.searchUtils.isSearching()
                ? true
                : searchMode;
        } else {
            this.searchMode = searchMode;
        }
    }

    setFilterBarOpen(open: boolean): void {
        this.filterOpen = open;

        let filterOffsetPages = [];
        this.filterOffset =
            this.filterOpen &&
            filterOffsetPages.indexOf(this.selectedPage?.sidebar) > -1 &&
            this.filterOpen;
    }

    hideSearch(): boolean {
        return this.selectedPage?.sidebar == "map";
    }

    toggleFilterBarOpen(): void {
        this.filterOpen = !this.filterOpen;

        let filterOffsetPages = ["map"];
        this.filterOffset =
            this.filterOpen &&
            filterOffsetPages.indexOf(this.selectedPage?.sidebar) > -1 &&
            this.filterOpen;
    }

    setNavigationBarHidden(hidden: boolean): void {
        this.navigationBarHidden = hidden;
    }

    setSideBarOpen(open: boolean): void {
        this.sideBarOpen = open;
    }

    setMenuItemsHidden(hidden: boolean): void {
        this.menuItemsHidden = hidden;
    }

    setProfileMenuHidden(hidden: boolean): void {
        this.profileMenuHidden = hidden;
    }

    setSetBarHidden(hideSideBar: boolean): void {
        this.hideSideBar = hideSideBar;
    }

    setShowBackButton(showBackButton: boolean): void {
        this.showBackButton = showBackButton;
    }

    toggleSideNav(): void {
        this.sideBarOpen = !this.sideBarOpen;
    }

    sideBarClicked(pinned: boolean = false): void {
        this.pinnedPageClicked = pinned;
        this.setSideBarOpen(this.$mdMedia("gt-sm"));
    }

    sidebarOffset(): boolean {
        return this.sideBarOpen && !this.smallScreen && !this.hideSideBar;
    }

    setSelectedSideBarItem(path: string): void {
        const newPage = this.paths.hasOwnProperty(path.split("/")[1])
            ? this.paths[path.split("/")[1]]
            : null;

        this.setAutoSidebar(true);
        if (newPage) {
            this.selectedPageChanged(this.selectedPage, newPage);
        }
        this.selectedPage = newPage;

        if (this.selectedPage.sidebar == "import") {
            this.selectedPage.icon = "import_export";
        } else if (this.selectedPage.sidebar == "results") {
            this.selectedPage.icon = "space_dashboard";
        } else {
            let pages = angular.copy(this.pages);
            if (this.isLeaderView) {
                pages = angular.copy(this.leaderPages);
            }
            angular.forEach(pages, (category) => {
                angular.forEach(category.pages, (page) => {
                    if (page.key == this.selectedPage.sidebar) {
                        this.selectedPage.icon = page.icon;
                    }
                });
            });
        }
    }

    selectedPageChanged(oldPage: any, newPage: any): void {
        if (oldPage) {
            this.pageChanged = oldPage.sidebar !== newPage.sidebar;
        } else {
            this.pageChanged = false;
        }
    }

    isSelectedSideBarItem(item: string, pinned: boolean = false): boolean {
        if (this.selectedPage) {
            return (
                this.selectedPage.sidebar === item &&
                this.pinnedPageClicked == pinned
            );
        }
        return false;
    }

    title(): string {
        return this.selectedPage ? this.selectedPage.title : "";
    }
}

angular
    .module("navigation")
    .service("NavigationBarHelperService", NavigationBarHelperService);
